<mat-chip-list #chipList>
  <mat-chip [removable]="removable" (removed)="remove(name,section)" class="mat-chip-p" style="border: 1px solid #929292;background: white;font-family: 'HELVETICA_NEUE_REGULAR';display: flex;align-items: center;">
    {{name}}
    <mat-icon matChipRemove *ngIf="removable" style="color:red;" (click)="remove(name,section)" >cancel</mat-icon>
  </mat-chip>
</mat-chip-list>